import { CanActivateFn, RedirectCommand, Route, Router } from '@angular/router';
import { palletByBarcodeResolver } from './resolver/pallet-scan.resolver';
import { ProductRelocationRepository } from './repositories/product-reloaction.repository';
import { ProductRelocationService } from './services/product-relocation.service';
import { inject } from '@angular/core';

export const productRelocationRoutes: Route[] = [
  {
    path: 'product-relocation',
    providers: [ProductRelocationRepository, ProductRelocationService],
    canDeactivate: [
      () => {
        const service = inject(ProductRelocationService);
        service.reset();
        service.loadedPallet.set(undefined);
      },
    ],
    children: [
      {
        // Step 1
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/scan-pallet/scan-pallet.component'),
      },
      {
        // Step 2
        path: ':pallet',
        pathMatch: 'full',
        loadComponent: () => import('./pages/pallet-products/pallet-products.component'),
        resolve: {
          pallet: palletByBarcodeResolver(true),
        },
      },
      {
        // Step 3
        path: ':pallet/:productId',
        loadComponent: () =>
          import('./pages/product-quantity/product-quantity.component'),
        pathMatch: 'full',
        resolve: {
          pallet: palletByBarcodeResolver(true),
        },
      },
      {
        // Step 4
        path: ':pallet/:productId/origin',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/origin-storage-location/origin-storage-location.component'),
        resolve: {
          pallet: palletByBarcodeResolver(true),
        },
        canActivate: [
          (async (route) => {
            const service = inject(ProductRelocationService);
            const router = inject(Router);
            const palletBarcode = route.paramMap.get('pallet');
            const productId = route.paramMap.get('productId');

            if (!service.productQuantitySet())
              return new RedirectCommand(
                router.createUrlTree(['/product-relocation', palletBarcode, productId])
              );

            return true;
          }) satisfies CanActivateFn,
        ],
      },
      {
        // Step 5
        path: ':pallet/:productId/destination',
        pathMatch: 'full',
        loadComponent: () =>
          import(
            './pages/destination-storage-location/destination-storage-location.component'
          ),
        resolve: {
          pallet: palletByBarcodeResolver(false),
        },
        canActivate: [
          (async (route) => {
            const service = inject(ProductRelocationService);
            const router = inject(Router);
            const palletBarcode = route.paramMap.get('pallet');
            const productId = route.paramMap.get('productId');

            if (!service.productQuantitySet())
              return new RedirectCommand(
                router.createUrlTree(['/product-relocation', palletBarcode, productId])
              );

            return true;
          }) satisfies CanActivateFn,
        ],
      },
    ],
  },
];
